import { Typography } from "@mui/material"

export function LinkedRateCardItem({ item }) {
    return (
        <li>
            <Typography variant="body2">{item.name}</Typography>
        </li>
    )
}
